<template>
    <div>
        <a-row>
            <a-col :span="1">
                <a-button type="primary" @click="visible=true">
                    新增
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="dataList.data" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a-divider v-if="row.type==='UserLevel'" type="vertical"/>
                <a v-if="row.type==='UserLevel'" style="padding-left:5px;color:red" @click="del(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="dataList" @change="onChange"/>
        <a-modal v-model="visible"
                 width="70%"
                 :centered="true"
                 :maskClosable="false"
                 :bodyStyle="modalBodyStyle"
                 title="编辑快码"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="add"
                 @cancel="resetForm">
            <a-row>
                <a-col :span="1"/>
                <a-col :span="2">
                    快码类型：
                </a-col>
                <a-col :span="4">
                    <my-select :select-value.sync="form.type" :data-list="lookUpType"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    快码编号：
                </a-col>
                <a-col :span="4">
                    <a-input v-model.trim="form.no"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    快码名称：
                </a-col>
                <a-col :span="4">
                    <a-input v-model.trim="form.name"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="1"/>
                <a-col :span="2">
                    序号：
                </a-col>
                <a-col :span="4">
                    <a-input-number style="width: 100%" v-model.trim="form.orderNo"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    新增明细：
                </a-col>
                <a-col :span="4">
                    <my-select :select-value.sync="form.append" :data-list="isChoice"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    删除明细：
                </a-col>
                <a-col :span="4">
                    <my-select :select-value.sync="form.delete" :data-list="isChoice"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="1"/>
                <a-col :span="2">
                    备注：
                </a-col>
                <a-col :span="11">
                    <a-input v-model.trim="form.remark"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 30px">
                <a-col :span="3">
                    <strong style="font-size: 20px">快码明细</strong>
                </a-col>
                <a-col :span="19"/>
                <a-col :span="2">
                    <a-button v-if="form.append==='true'" style="float: right" type="primary" @click="addLine">
                        新增
                    </a-button>
                </a-col>
            </a-row>
            <a-divider style="margin: 5px 0"/>
            <a-table :columns="columnsChildren"
                     size="small"
                     :data-source="form.lookUpLines"
                     :pagination="false"
                     :scroll="{y:'30vh'}"
                     rowKey="id">
                <template
                        v-for="col in ['name', 'value','remark']"
                        :slot="col"
                        slot-scope="text, record">
                    <div :key="col">
                        <a-input v-model.trim="record[col]"/>
                    </div>
                </template>
                <template slot="orderNo" slot-scope="text, record">
                    <a-input-number style="width: 100%" v-model.trim="record.orderNo"/>
                </template>
                <template slot="operation" slot-scope="text, record">
                    <a v-if="form.delete==='true'" style="color: red" @click="deleteLine(record)">{{record.isDel==='1'?'已删除':'删除'}}</a>
                </template>
            </a-table>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {getLookUpQueryList, lookUpEditDetail, lookUpDelDetail} from './js/ApiSystem';
    import {getLookUpType, getIsChoice} from "../../config/LookUpCache";
    import {modalBodyStyle} from "../../config/Config"

    const columns = [
        {
            title: '类别',
            dataIndex: 'type',
            key: 'type',
            ellipsis: true,
        },
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'menuIcon',
            ellipsis: true,
        },
        {
            title: '快码编号',
            dataIndex: 'no',
            key: 'no',
            ellipsis: true,
        },
        {
            title: '快码名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '是否可新增明细',
            dataIndex: 'append',
            key: 'append',
            ellipsis: true,
        },
        {
            title: '是否删除明细',
            dataIndex: 'delete',
            key: 'delete',
            ellipsis: true,
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            scopedSlots: {customRender: 'operation'},
            ellipsis: true,
        },
    ];
    const columnsChildren = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            scopedSlots: {customRender: 'orderNo'},
            ellipsis: true,
        },
        {
            title: '项目名称',
            dataIndex: 'name',
            key: 'name',
            scopedSlots: {customRender: 'name'},
            ellipsis: true,
        },
        {
            title: '项目值',
            dataIndex: 'value',
            key: 'value',
            scopedSlots: {customRender: 'value'},
            ellipsis: true,
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {customRender: 'remark'},
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '80px',
            scopedSlots: {customRender: 'operation'},
        },
    ];
    export default {
        data() {
            return {
                columns,
                columnsChildren,
                modalBodyStyle,
                dataList: {},
                visible: false,
                delVisible: false,
                line: {},
                form: {
                    type: '',
                    orderNo: '',
                    no: '',
                    name: '',
                    append: 'true',
                    delete: 'true',
                    remark: '',
                    lookUpLines: []
                },
                lookUpType: [],
                isChoice: []
            }
        },
        methods: {
            //新增
            add() {
                this.form.orderNo = this.form.orderNo + '';
                this.form.lookUpLines.forEach(item=>{
                    item.orderNo = item.orderNo + ''
                });
                lookUpEditDetail(this.form).then(() => {
                    this.getData({});
                    this.visible = false;
                    this.resetForm();
                })
            },
            edit(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.visible = true
            },
            //删除
            del(row) {
                this.line = row;
                this.delVisible = true;
            },
            deleteLine(row) {
                row.isDel = '1';
                let index = this.form.lookUpLines.findIndex(item => {
                    return item === row
                });
                this.form.lookUpLines.splice(index, 1)
            },
            getData(param) {
                getLookUpQueryList(param).then(res => {
                    this.dataList = res.data;
                })
            },
            addLine() {
                this.form.lookUpLines.push({});
            },
            /**
             * 重置form
             */
            resetForm() {
                this.form = {
                    lookUpType: '',
                    orderNo: '',
                    lookNo: '',
                    lookName: '',
                    append: 'true',
                    delete: 'true',
                    remark: '',
                    lookUpLines: []
                }
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                getLookUpQueryList({baseDto: baseDto}).then(res => {
                    this.data = res.data;
                })
            },
            // 删除确认
            delOk() {
                lookUpDelDetail({id: this.line.id}).then(() => {
                    this.getData({})
                })
            },
            cancel() {
                this.delVisible = false;
            }
        },
        created() {
            this.getData({});
            getLookUpType((cacheData) => {
                this.lookUpType = cacheData
            });
            getIsChoice((cacheDate) => {
                this.isChoice = cacheDate
            })
        }
    }
</script>

<style scoped>
</style>
